import { gql } from "@apollo/client";

const RECHAZAR_VISITA = gql`
mutation RechazarVisita($input: VisitaHonorarioInput!, $idVisita: Int!, $observacion: String!) {
    rechazarVisita(input: $input, idVisita: $idVisita, observacion: $observacion)
}`;

export default RECHAZAR_VISITA;